// extracted by mini-css-extract-plugin
export default {"overridesPrimaryHomepageButton":"PrimaryHomepageButton-module--overrides--PrimaryHomepageButton--Tp5u2"};